// extracted by mini-css-extract-plugin
export default {"container":"Layout_container__GnERz","layout":"Layout_layout__Tk5kE","main":"Layout_main__TIREm"};